import { render, staticRenderFns } from "./HistoricoList.vue?vue&type=template&id=40f1666b&scoped=true&"
import script from "./HistoricoList.vue?vue&type=script&lang=js&"
export * from "./HistoricoList.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoList.vue?vue&type=style&index=0&id=40f1666b&lang=scss&scoped=true&"
import style1 from "./HistoricoList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f1666b",
  null
  
)

export default component.exports